import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

export interface AccordionItem {
  key: string,
  value: string
}

@Component({
  selector: 'kion-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent implements OnInit, OnChanges {

  @Input() items: AccordionItem[];

  accordionItems: AccordionItem[];
  toggledItems: {item: AccordionItem, open: boolean}[] = [];

  ngOnInit(): void {
    this.accordionItems = this.items;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.items) {
      if (changes.items.currentValue !== changes.items.previousValue) {
        this.accordionItems = changes.items.currentValue;
      }
    }
  }

  isOpen(accordionItem: AccordionItem): boolean {
    return this.toggledItems.find(item => item.item === accordionItem)?.open
  }

  toggle(object: {item: AccordionItem, open: boolean}): void {
    this.toggledItems = this.toggledItems.map(
      item => {
        if (item.item === object.item) {
          return {
            ...object
          }
        }
        return {
          ...item
        }
      }
    )
  }
}
